import { render } from "./PimFeedbackPanelOld.vue?vue&type=template&id=5e9cf5b0&ts=true"
import script from "./PimFeedbackPanelOld.vue?vue&type=script&lang=ts"
export * from "./PimFeedbackPanelOld.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__